import Service from '../Service'
import AuthService from '../AuthService'

const News = {
    getNewsList(page) {
        return AuthService.get('/api/news?page='+page).then(res => {
            return res;
        });
    },
    getNewsByID(id){
        return AuthService.get(`/api/news/${id}`).then(res => {
            return res;
        });
    },
    deleteNewsByID(id){
        return AuthService.delete(`/api/news/${id}`).then(res => {
            return res;
        })
    },
    updateNewsByID(id,data){
        let formData = new FormData();
        formData.append('topic',data.topicNews);
        formData.append('shortDescription',data.caption);
        formData.append('description',data.detail);
        formData.append('eventPlace',data.subDetails);
        formData.append('eventDate',data.date);
        formData.append('mainPicture',data.image);

        return AuthService.post(`/api/update-news/${id}`, formData,{
            headers: {
                "Content-Type": 'multipart/form-data',
            }
        }).then(res => {
            return res;
        });
    },
    save(data) {
        let formData = new FormData();

        formData.append('topic',data.topicNews);
        formData.append('shortDescription',data.caption);
        formData.append('description',data.detail);
        formData.append('eventPlace',data.subDetails);
        formData.append('eventDate',data.date);
        formData.append('mainPicture',data.image);

        return AuthService.post("/api/news", formData,{
            headers: {
                "Content-Type": 'multipart/form-data',
            }
        }).then(res => {
            return res;
        });
    },
    uploadImage(data) {
        let formData = new FormData();
        formData.append('newsPicture',data);
        return AuthService.post("/api/upload-image", formData,{
            headers: {
                "Content-Type": 'multipart/form-data',
            }
        }).then(res => {
            return res;
        });
    },
}

export default News;
